import {
  Button,
  ContextMenu,
  Flex,
  FlexItem,
  Icon,
  IconArrow1Down,
  makeButtonWithMenu,
  ModalConfirm
} from 'mailup-web-components'
import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'

import {
  useRecoilCallback,
  useRecoilState,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState
} from 'recoil'

import styled from '@emotion/styled'
import { notifyParent, STORE_KEY_ACCOUNT, storeGet } from 'mailup-react-helpers'
import { showPreviewCallback } from 'Pages/Campaign/recoil/callbacks/callbackEditBee'
import { beePluginState, editorState } from 'Pages/Campaign/recoil/state/bee'
import { campaignState } from 'Pages/Campaign/recoil/state/campaign'
import { modalConfirmEditMessageState } from 'Pages/Campaign/recoil/state/modals'
import { pageState } from 'Pages/Campaign/recoil/state/page'
import { previewState } from 'Pages/Campaign/recoil/state/preview'
import { useHistory } from 'react-router-dom'
import {
  CHANGE_TEMPLATE,
  CLOSE_PREVIEW,
  EXIT,
  PREVIEW,
  SAVE_EXIT,
  STRUCTURE
} from './const'
import { modalContentsDefaultsState } from './ModalContentDefaults/recoil/state'

const StyledSaveMessageContainer = styled.span`
  display: flex;
  align-items: center;

  .left-btn {
    border-radius: 4px 0 0 4px;
    &:hover {
      cursor: pointer;
    }
  }

  .right-btn {
    border-radius: 0 4px 4px 0;
    margin-left: 1px;
    padding: 0 13px;
  }
`

const StyledContextMenu = styled(ContextMenu)`
  right: -40px !important;
  position: absolute !important;
`

const StyledButtonClosePreview = styled(Icon)`
  cursor: pointer;
  font-size: 24px;
  font-wight: 500;
  color: rgb(37, 37, 37);
  margin-right: 10px;
  :hover:before {
    color: rgb(37, 37, 37);
  }
`

export const EditTemplateButtons = () => {
  const intl = useIntl()
  const history = useHistory()
  const account = storeGet(STORE_KEY_ACCOUNT)
  const setPageState = useSetRecoilState(pageState)
  const {
    loadedInstance: beePluginLoaded,
    instance,
    onSave
  } = useRecoilValue(beePluginState)
  const setBeePluginState = useSetRecoilState(beePluginState)

  const [modalConfirm, setModalConfirm] = useRecoilState(
    modalConfirmEditMessageState
  )
  const setEditor = useSetRecoilState(editorState)

  const [showStructure, setShowStructure] = useState(false)
  const [{ callPreview, previewOnLoad }, setPreviewState] =
    useRecoilState(previewState)

  const resetModalConfirm = useResetRecoilState(modalConfirmEditMessageState)
  const resetPreview = useResetRecoilState(previewState)

  const showPreview = useRecoilCallback(showPreviewCallback, [])
  const { EmailOptions } = useRecoilValue(campaignState)
  const setModalContentsDefaults = useSetRecoilState(modalContentsDefaultsState)

  useEffect(() => {
    if (callPreview) {
      setPreviewState((prev) => ({
        ...prev,
        callPreview: false
      }))
      showPreview(EmailOptions.IdMessage, true)
    }
  }, [callPreview])

  useEffect(() => {
    if (onSave) {
      instance.save()
    }
  }, [onSave])

  const handleClickBtn = (value) => {
    switch (value) {
      case CHANGE_TEMPLATE: {
        setModalConfirm((prev) => ({
          ...prev,
          show: true,
          title: intl.formatMessage({ id: 'Load.Bee.ConfirmExitTitle' }),
          message: intl.formatMessage({
            id: 'Load.Bee.ConfirmExitDescription'
          }),
          stringCancel: intl.formatMessage({ id: 'Load.MailupCommon.No' }),
          stringConfirm: intl.formatMessage({ id: 'Load.MailupCommon.Yes' }),
          onClickCancel: () => {
            setModalConfirm((prev) => ({ prev, show: false }))
          },
          onClickConfirm: () => {
            setEditor((prev) => ({ ...prev, initialStructure: undefined }))
            resetModalConfirm()
            resetPreview()
            setPageState((prev) => ({
              ...prev,
              step2SelectTemplate: true,
              displayCarousel: true
            }))
          }
        }))
        break
      }
      case EXIT: {
        setModalConfirm((prev) => ({
          ...prev,
          show: true,
          title: intl.formatMessage({ id: 'Load.Bee.ConfirmExitTitle' }),
          message: intl.formatMessage({
            id: 'Load.Bee.ConfirmExitDescription'
          }),
          stringCancel: intl.formatMessage({ id: 'Load.MailupCommon.No' }),
          stringConfirm: intl.formatMessage({ id: 'Load.MailupCommon.Yes' }),
          onClickCancel: () => {
            setModalConfirm((prev) => ({ prev, show: false }))
          },
          onClickConfirm: () => {
            setEditor((prev) => ({ ...prev, initialStructure: undefined }))
            resetModalConfirm()
            resetPreview()
            notifyParent('setFullScreen', [false])
            history.push(`/automation/contentsCampaign/list`)
          }
        }))
        break
      }
      case PREVIEW: {
        // chiama la callbak del BEE e imposta callPreview a true quando ha finito il save
        setPreviewState((prev) => ({
          ...prev,
          previewOnLoad: true
        }))
        setBeePluginState((prev) => ({
          ...prev,
          onSave: PREVIEW
        }))

        break
      }
      case STRUCTURE: {
        setShowStructure(!showStructure)
        instance.toggleStructure()
        break
      }

      case CLOSE_PREVIEW: {
        resetPreview()
        break
      }

      case SAVE_EXIT: {
        setBeePluginState((prev) => ({
          ...prev,
          onSave: SAVE_EXIT
        }))
        break
      }

      case 'CONTENTDEFAULTS': {
        if (
          account.IdOffer === 3 ||
          account.IdOffer === 2 ||
          account.IdOffer === 1 ||
          account.IdOffer === 8
        ) {
          setModalContentsDefaults((prev) => ({
            ...prev,
            show: true
          }))
        } else {
          notifyParent('redirectMainFrame', [
            'messages_app_redirector.aspx?r=/messages/email/contentdefaults'
          ])
        }
        break
      }
    }
  }

  const ButtonComponent = () => (
    <Button className='right-btn' kind='primary' disabled={!beePluginLoaded}>
      <IconArrow1Down />
    </Button>
  )

  const MenuComponent = () => {
    const items = [
      {
        label: intl.formatMessage({ id: 'Load.Bee.Preview' }),
        value: PREVIEW,
        onClick: handleClickBtn
      },
      {
        label: showStructure
          ? intl.formatMessage({ id: 'Load.Bee.HideStructure' })
          : intl.formatMessage({ id: 'Load.Bee.Structure' }),
        value: STRUCTURE,
        onClick: handleClickBtn
      },
      {
        separator: true,
        label: intl.formatMessage({ id: 'Load.NavMenu.EmailContentDefaults' }),
        value: 'CONTENTDEFAULTS',
        onClick: handleClickBtn
      }
    ]

    return <StyledContextMenu items={items} />
  }

  const ButtonWithMenu = makeButtonWithMenu(ButtonComponent, MenuComponent)

  const handleClickConfirm = modalConfirm.onClickConfirm
  const handleClickCancel = modalConfirm.onClickCancel

  return (
    <>
      {modalConfirm.show && (
        <ModalConfirm
          show={modalConfirm.show}
          showClose
          closeOnOverlayClick
          title={modalConfirm.title}
          message={modalConfirm.message}
          variant='primary'
          stringConfirm={modalConfirm.stringConfirm}
          onClickConfirm={handleClickConfirm}
          stringCancel={modalConfirm.stringCancel}
          onClickCancel={handleClickCancel}
        />
      )}

      <Flex>
        {previewOnLoad && (
          <FlexItem>
            <StyledButtonClosePreview
              icon='cancel-circle'
              family='sli'
              onClick={() => handleClickBtn(CLOSE_PREVIEW)}
            />
          </FlexItem>
        )}

        {!previewOnLoad && (
          <>
            <FlexItem margin='0 8px 0 0'>
              <Button
                disabled={!beePluginLoaded}
                kind='neutral'
                onClick={() => handleClickBtn(CHANGE_TEMPLATE)}
                data-mu-test='campaign-wizard__step-2__button__change-template'
              >
                {intl.formatMessage({
                  id: 'Load.ContentsCampaignWizard.ChangeTemplate'
                })}
              </Button>
            </FlexItem>

            <FlexItem margin='0 8px 0 0'>
              <Button
                disabled={!beePluginLoaded}
                kind='neutral'
                onClick={() => handleClickBtn(EXIT)}
                data-mu-test='exit'
              >
                {intl.formatMessage({ id: 'Load.Common.Exit' })}
              </Button>
            </FlexItem>
            <FlexItem>
              <StyledSaveMessageContainer>
                <Button
                  className='left-btn'
                  kind='primary'
                  size='md'
                  disabled={!beePluginLoaded}
                  onClick={() => handleClickBtn(SAVE_EXIT)}
                  data-mu-test='campaign-edit-saveAndExitCTA'
                >
                  {intl.formatMessage({ id: 'Load.Common.SaveAndExit' })}
                </Button>
                <ButtonWithMenu
                  disabled={!beePluginLoaded}
                  direction='down'
                  data-mu-test='campaign-edit-showStructureMenuCTA'
                />
              </StyledSaveMessageContainer>
            </FlexItem>
          </>
        )}
      </Flex>
    </>
  )
}
